import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, RadioButtonGroup } from 'carbon-components-react';
import { RadioButton } from 'carbon-components-react/lib/components/RadioButton/RadioButton';
import { CHANNELS } from 'types';

const propTypes = {
  channelTypeHandler: PropTypes.func.isRequired,
  channelType: PropTypes.string.isRequired
};

type Props = PropTypes.InferProps<typeof propTypes>;

/**
 * channelType
 */
const ChannelTypes: React.FC<Props | any> = (props: Props) => {
  const { channelTypeHandler, channelType } = props;
  const onChangeHandler = (value: any) => {
    channelTypeHandler(value);
  };
  return (
    <FormGroup legendText="Channel type" className="channel-type">
      <RadioButtonGroup
        labelPosition="right"
        defaultSelected={channelType}
        name="channelType"
        valueSelected={channelType}
        orientation="vertical"
        onChange={(val: any) => onChangeHandler(val)}
      >
        {Object.entries({
          [CHANNELS.LEGACY]: 'Email',
          [CHANNELS.SWX_AUTOMATE]: 'SmarterWX Automate',
          [CHANNELS.WEBHOOK]: 'Web Hook',
          [CHANNELS.FALLBACK]: 'Legacy Fallback (Not editable)'
        })
          .filter(
            ([channel]) =>
              channelType === 'FALLBACK' || channel !== CHANNELS.FALLBACK
          )
          .map(([channel, text]) => (
            <RadioButton
              id={channel}
              key={channel}
              labelText={text}
              value={channel}
            />
          ))}
      </RadioButtonGroup>
    </FormGroup>
  );
};

ChannelTypes.defaultProps = {
  channelType: '',
  channelTypeHandler: () => {}
};

export default ChannelTypes;
